webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(398);
	module.exports = __webpack_require__(596);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.palette = exports.PORT_SEP = exports.PAD = exports.WALL_SIZE = exports.MARBLE_RADIUS = exports.GEOM_SCALE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(41);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GEOM_SCALE = exports.GEOM_SCALE = 1;
	var MARBLE_RADIUS = exports.MARBLE_RADIUS = 15 * GEOM_SCALE;
	var WALL_SIZE = exports.WALL_SIZE = 5 * GEOM_SCALE;
	var PAD = exports.PAD = 1 * GEOM_SCALE;
	var PORT_SEP = exports.PORT_SEP = (0, _utils.degrees)(45);
	
	var palette = exports.palette = {
	  turquoise: 0x1abc9c,
	  green: 0x2ecc71,
	  blue: 0x3498db,
	  purple: 0x9b59b6,
	  black: 0x34495e,
	  yellow: 0xf1c40f,
	  orange: 0xe67e22,
	  red: 0xe74c3c,
	  white: 0xecf0f1,
	  grey: 0x95a5a6,
	  darkTurquoise: 0x16a085,
	  darkGreen: 0x27ae60,
	  darkBlue: 0x2980b9,
	  darkPurple: 0x8e44ad,
	  darkBlack: 0x2c3e50,
	  darkYellow: 0xf39c12,
	  darkOrange: 0xd35400,
	  darkRed: 0xc0392b,
	  darkWhite: 0xbdc3c7,
	  darkGrey: 0x7f8c8d
	};
	
	palette.str = Object.entries(palette).reduce(function (colours, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var name = _ref2[0];
	  var colour = _ref2[1];
	  return _extends({}, colours, _defineProperty({}, name, '#' + colour.toString(16)));
	}, {});

/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _utils = __webpack_require__(41);
	
	var noop = function noop(val) {
	  return function () {
	    return val;
	  };
	};
	
	var common = Symbol('Component.Common');
	
	var Component = {
	  registered: {},
	
	  create: function create(name, spec) {
	    var id = Symbol('Component(' + name + ')');
	
	    var _afterAdd = spec.afterAdd || noop();
	    var _beforeRemove = spec.beforeRemove || noop();
	    var _updateFromStore = spec.updateFromStore || noop();
	
	    var component = Object.assign({}, spec, {
	      name: name,
	      componentId: id,
	      instances: [],
	      initialState: spec.initialState || function () {
	        return {};
	      },
	
	      create: function create(props) {
	        var state = component.initialState(props);
	        var instance = spec.create(props, state);
	        instance.id = spec.id || instance.id;
	        instance[id] = state;
	        instance[common] = { x: props.x, y: props.y };
	        component.setPosition(instance, props.x, props.y);
	        return instance;
	      },
	      getState: function getState(instance) {
	        return instance[id];
	      },
	      afterAdd: function afterAdd(instance) {
	        component.instances.push(instance);
	        _afterAdd.apply(this, arguments);
	      },
	      beforeRemove: function beforeRemove(instance) {
	        (0, _utils.remove)(component.instances, instance);
	        _beforeRemove.apply(this, arguments);
	      },
	      setPosition: function setPosition(instance, x, y) {
	        var commonState = instance[common];
	        var translation = {
	          x: x - commonState.x,
	          y: y - commonState.y
	        };
	
	        if (instance.type === 'body') {
	          _matterJs.Body.translate(instance, translation);
	        } else if (instance.type === 'composite') {
	          _matterJs.Composite.translate(instance, translation);
	        }
	
	        commonState.x = x;
	        commonState.y = y;
	      },
	      updateFromStore: function updateFromStore(instance, storeState) {
	        component.setPosition(instance, storeState.x, storeState.y);
	        _updateFromStore(instance, storeState);
	      }
	    });
	
	    Component.registered[id] = Component.registered[name] = component;
	    return component;
	  },
	  get: function get(name) {
	    if (!Component.registered[name]) throw new Error('Component ' + name.toString() + ' not found');
	    return Component.registered[name];
	  }
	};
	
	exports.default = Component;

/***/ },
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mirror = exports.toPath = exports.degrees = exports.remove = exports.hasOwnProperty = undefined;
	
	var _flatMap = __webpack_require__(686);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = exports.hasOwnProperty = function hasOwnProperty(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	};
	
	var remove = exports.remove = function remove(arr, value) {
	  var idx = arr.indexOf(value);
	  if (idx === -1) return undefined;
	  return arr.splice(idx, 1)[0];
	};
	
	var degrees = exports.degrees = function degrees(n) {
	  return n * (Math.PI / 180);
	};
	
	var toPath = exports.toPath = function toPath(points) {
	  return (0, _flatMap2.default)(points, function (_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    return [x, y];
	  });
	};
	
	var axisToCoord = { x: 'y', y: 'x' };
	
	var mirror = exports.mirror = function mirror(axis, path) {
	  return path.concat(path.map(function (point) {
	    var newPoint = { x: point.x, y: point.y };
	    newPoint[axisToCoord[axis]] *= -1;
	    return newPoint;
	  }).reverse());
	};

/***/ },
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = exports.RoundedRectangle = exports.Rectangle = exports.Polygon = exports.Ellipse = exports.Circle = exports.BezierCurve = exports.Arc = exports.Graphics = undefined;
	
	var _Graphics = __webpack_require__(369);
	
	Object.defineProperty(exports, 'Graphics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graphics).default;
	  }
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _createGraphicsComponent = __webpack_require__(370);
	
	var _createGraphicsComponent2 = _interopRequireDefault(_createGraphicsComponent);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rotate = function rotate(base, angle, point) {
	  return _matterJs.Vector.add(base, _matterJs.Vector.rotate(point, angle));
	};
	
	var rotatePath = function rotatePath(base, angle, points) {
	  return points.map(function (point) {
	    return rotate(base, angle, point);
	  });
	};
	
	var Arc = exports.Arc = (0, _createGraphicsComponent2.default)('Arc', function (graphics, _ref) {
	  var cx = _ref.cx;
	  var cy = _ref.cy;
	  var radius = _ref.radius;
	  var startAngle = _ref.startAngle;
	  var endAngle = _ref.endAngle;
	  var antiClockwise = _ref.antiClockwise;
	  var x1 = _ref.x1;
	  var y1 = _ref.y1;
	  var x2 = _ref.x2;
	  var y2 = _ref.y2;
	
	  if (cx != null && cy != null && radius != null && startAngle != null && endAngle != null) {
	    graphics.arc(cx, cy, radius, startAngle, endAngle, antiClockwise);
	  } else if (x1 != null && x2 != null && y1 != null && y2 != null && radius != null) {
	    graphics.arcTo(x1, y1, x2, y2, radius);
	  } else {
	    throw new Error('Arc must be given props matching either Pixi Graphics arc or arcTo');
	  }
	});
	
	var BezierCurve = exports.BezierCurve = (0, _createGraphicsComponent2.default)('BezierCurve', function (graphics, _ref2) {
	  var cpX = _ref2.cpX;
	  var cpY = _ref2.cpY;
	  var cpX2 = _ref2.cpX2;
	  var cpY2 = _ref2.cpY2;
	  var toX = _ref2.toX;
	  var toY = _ref2.toY;
	  return graphics.BezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY);
	});
	
	var Circle = exports.Circle = (0, _createGraphicsComponent2.default)('Circle', function (graphics, _ref3) {
	  var _ref3$x = _ref3.x;
	  var x = _ref3$x === undefined ? 0 : _ref3$x;
	  var _ref3$y = _ref3.y;
	  var y = _ref3$y === undefined ? 0 : _ref3$y;
	  var radius = _ref3.radius;
	  return graphics.drawCircle(x, y, radius);
	});
	
	var Ellipse = exports.Ellipse = (0, _createGraphicsComponent2.default)('Ellipse', function (graphics, _ref4) {
	  var _ref4$x = _ref4.x;
	  var x = _ref4$x === undefined ? 0 : _ref4$x;
	  var _ref4$y = _ref4.y;
	  var y = _ref4$y === undefined ? 0 : _ref4$y;
	  var width = _ref4.width;
	  var height = _ref4.height;
	  return graphics.drawEllipse(x, y, width, height);
	});
	
	var Polygon = exports.Polygon = (0, _createGraphicsComponent2.default)('Polygon', function (graphics, _ref5) {
	  var path = _ref5.path;
	  return graphics.drawPolygon(path);
	});
	
	var Rectangle = exports.Rectangle = (0, _createGraphicsComponent2.default)('Rectangle', function (graphics, _ref6) {
	  var _ref6$x = _ref6.x;
	  var x = _ref6$x === undefined ? 0 : _ref6$x;
	  var _ref6$y = _ref6.y;
	  var y = _ref6$y === undefined ? 0 : _ref6$y;
	  var width = _ref6.width;
	  var height = _ref6.height;
	  return graphics.drawRect(x, y, width, height);
	});
	
	var RoundedRectangle = exports.RoundedRectangle = (0, _createGraphicsComponent2.default)('RoundedRectangle', function (graphics, _ref7) {
	  var _ref7$x = _ref7.x;
	  var x = _ref7$x === undefined ? 0 : _ref7$x;
	  var _ref7$y = _ref7.y;
	  var y = _ref7$y === undefined ? 0 : _ref7$y;
	  var width = _ref7.width;
	  var height = _ref7.height;
	  var radius = _ref7.radius;
	  return graphics.drawRoundedRect(x, y, width, height, radius);
	});
	
	var Arrow = exports.Arrow = (0, _createGraphicsComponent2.default)('Arrow', function (graphics, _ref8) {
	  var _ref8$x = _ref8.x;
	  var x = _ref8$x === undefined ? 0 : _ref8$x;
	  var _ref8$y = _ref8.y;
	  var y = _ref8$y === undefined ? 0 : _ref8$y;
	  var _ref8$angle = _ref8.angle;
	  var angle = _ref8$angle === undefined ? 0 : _ref8$angle;
	  var width = _ref8.width;
	  var height = _ref8.height;
	  var _ref8$depth = _ref8.depth;
	  var depth = _ref8$depth === undefined ? 0 : _ref8$depth;
	  return graphics.drawPolygon((0, _utils.toPath)(rotatePath({ x: x, y: y }, angle, [{ x: 0, y: height / 2 }, { x: -width / 2, y: -height / 2 }, { x: 0, y: -(height / 2) - depth }, { x: width / 2, y: -height / 2 }])));
	});

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputSensor = _Component2.default.create('Input.Sensor', {
	  width: 2 * (_constants.MARBLE_RADIUS + _constants.PAD),
	  height: _constants.WALL_SIZE,
	
	  create: function create(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	
	    return _matterJs.Bodies.rectangle(x, y, InputSensor.width, InputSensor.height, {
	      isSensor: true
	    });
	  },
	
	
	  collisions: {
	    Marble: {
	      start: function start(body, state, marble) {
	        Input.getState(body.parent).waiting.push(marble);
	      },
	      end: function end(body, state, marble) {
	        (0, _utils.remove)(Input.getState(body.parent).waiting, marble);
	      }
	    }
	  }
	});
	
	var Input = _Component2.default.create('Input', {
	  width: 2 * (_constants.MARBLE_RADIUS + _constants.WALL_SIZE + _constants.PAD),
	  height: 2 * (_constants.WALL_SIZE + _constants.MARBLE_RADIUS),
	  initialState: function initialState(_ref2) {
	    var _ref2$rate = _ref2.rate;
	    var rate = _ref2$rate === undefined ? 100 : _ref2$rate;
	
	    return {
	      rate: rate,
	      waiting: []
	    };
	  },
	  create: function create(_ref3) {
	    var x = _ref3.x;
	    var y = _ref3.y;
	    var isStatic = _ref3.isStatic;
	    var _ref3$angle = _ref3.angle;
	    var angle = _ref3$angle === undefined ? 0 : _ref3$angle;
	
	    var body = _matterJs.Body.create({
	      isStatic: isStatic,
	      parts: [_matterJs.Bodies.rectangle(x + _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2 + _constants.PAD, y, _constants.WALL_SIZE, Input.height - _constants.WALL_SIZE), _matterJs.Bodies.rectangle(x - (_constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2 + _constants.PAD), y, _constants.WALL_SIZE, Input.height - _constants.WALL_SIZE, { render: { fillStyle: 'red' } }), _matterJs.Bodies.rectangle(x, y + _constants.MARBLE_RADIUS + _constants.WALL_SIZE, Input.width, _constants.WALL_SIZE), InputSensor.create({ x: x, y: y + _constants.MARBLE_RADIUS })]
	    });
	
	    _matterJs.Body.rotate(body, angle);
	
	    return body;
	  },
	  afterAdd: function afterAdd(body, state, game) {
	    state.game = game;
	    state.lastConsumed = game.engine.timing.timestamp;
	  },
	  canConsume: function canConsume(body) {
	    var _Input$getState = Input.getState(body);
	
	    var lastConsumed = _Input$getState.lastConsumed;
	    var rate = _Input$getState.rate;
	    var waiting = _Input$getState.waiting;
	    var game = _Input$getState.game;
	    var timestamp = game.engine.timing.timestamp;
	
	
	    return timestamp - lastConsumed > rate && waiting.length;
	  },
	  consume: function consume(body) {
	    var state = Input.getState(body);
	    var _state$game = state.game;
	    var world = _state$game.world;
	    var engine = _state$game.engine;
	
	    var consumed = state.waiting.shift();
	
	    _matterJs.World.remove(world, consumed);
	    state.lastConsumed = engine.timing.timestamp;
	
	    return consumed;
	  }
	});
	
	exports.default = Input;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Marble = __webpack_require__(84);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OutputSensor = _Component2.default.create('Output.Sensor', {
	  width: 2 * (_constants.MARBLE_RADIUS + _constants.PAD),
	  height: 2 * _constants.MARBLE_RADIUS,
	
	  create: function create(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	
	    return _matterJs.Bodies.rectangle(x, y, OutputSensor.width, OutputSensor.height, {
	      isSensor: true
	    });
	  },
	
	
	  collisions: {
	    Marble: {
	      start: function start(body) {
	        Output.getState(body.parent).blockers += 1;
	      },
	      end: function end(body) {
	        Output.getState(body.parent).blockers -= 1;
	      }
	    }
	  }
	});
	
	var Output = _Component2.default.create('Output', {
	  width: 2 * (_constants.MARBLE_RADIUS + _constants.WALL_SIZE + _constants.PAD),
	  height: _constants.WALL_SIZE + _constants.MARBLE_RADIUS * 2,
	
	  initialState: function initialState(_ref2) {
	    var _ref2$rate = _ref2.rate;
	    var rate = _ref2$rate === undefined ? 500 : _ref2$rate;
	
	    return {
	      rate: rate,
	      blockers: 0
	    };
	  },
	  create: function create(_ref3) {
	    var x = _ref3.x;
	    var y = _ref3.y;
	    var isStatic = _ref3.isStatic;
	    var _ref3$angle = _ref3.angle;
	    var angle = _ref3$angle === undefined ? 0 : _ref3$angle;
	
	    var body = _matterJs.Body.create({
	      isStatic: isStatic,
	      parts: [_matterJs.Bodies.rectangle(x + _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2 + _constants.PAD, y, _constants.WALL_SIZE, _constants.MARBLE_RADIUS * 2), _matterJs.Bodies.rectangle(x - (_constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2 + _constants.PAD), y, _constants.WALL_SIZE, _constants.MARBLE_RADIUS * 2), _matterJs.Bodies.rectangle(x, y - (_constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2), Output.width, _constants.WALL_SIZE), OutputSensor.create({ x: x, y: y })]
	    });
	
	    _matterJs.Body.rotate(body, angle);
	
	    return body;
	  },
	  afterAdd: function afterAdd(body, state, game) {
	    state.game = game;
	    state.lastProduced = game.engine.timing.timestamp;
	  },
	  canProduce: function canProduce(body) {
	    var _Output$getState = Output.getState(body);
	
	    var lastProduced = _Output$getState.lastProduced;
	    var rate = _Output$getState.rate;
	    var blockers = _Output$getState.blockers;
	    var game = _Output$getState.game;
	    var timestamp = game.engine.timing.timestamp;
	
	
	    return timestamp - lastProduced > rate && !blockers;
	  },
	  produce: function produce(body, value) {
	    var state = Output.getState(body);
	    var _state$game = state.game;
	    var world = _state$game.world;
	    var engine = _state$game.engine;
	
	
	    _matterJs.World.add(world, _Marble2.default.create({
	      x: body.position.x,
	      y: body.position.y,
	      value: value
	    }));
	
	    state.lastProduced = engine.timing.timestamp;
	  }
	});
	
	exports.default = Output;

/***/ },
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _constants = __webpack_require__(23);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Marble = _Component2.default.create('Marble', {
	  initialState: function initialState(_ref) {
	    var value = _ref.value;
	
	    return {
	      value: value
	    };
	  },
	  create: function create(_ref2) {
	    var x = _ref2.x;
	    var y = _ref2.y;
	
	    return _matterJs.Bodies.circle(x, y, _constants.MARBLE_RADIUS, {
	      force: {
	        x: _matterJs.Common.random(-0.001, 0.001),
	        y: _matterJs.Common.random(-0.001, 0.001)
	      },
	      friction: 0.1
	    });
	  },
	  getValue: function getValue(body) {
	    return Marble.getState(body).value;
	  },
	  setValue: function setValue(body, value) {
	    Marble.getState(body).value = value;
	    return value;
	  },
	  afterUpdate: function afterUpdate(body, state, _ref3) {
	    var bounds = _ref3.bounds;
	    var world = _ref3.world;
	
	    if (!_matterJs.Bounds.overlaps(bounds, body.bounds)) {
	      _matterJs.World.remove(world, body);
	    }
	  }
	});
	
	exports.default = Marble;

/***/ },
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.restore = exports.clear = exports.selectMachine = exports.moveMachine = exports.deleteMachine = exports.addMachine = undefined;
	
	var _uniqueId = __webpack_require__(699);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _types = __webpack_require__(226);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var addMachine = exports.addMachine = function addMachine(machineType, x, y, props) {
	  var select = arguments.length <= 4 || arguments[4] === undefined ? true : arguments[4];
	  return {
	    type: types.MACHINES.ADD,
	    machineType: machineType,
	    id: (0, _uniqueId2.default)(machineType),
	    x: x,
	    y: y,
	    props: props,
	    select: select
	  };
	};
	
	var deleteMachine = exports.deleteMachine = function deleteMachine(id) {
	  return {
	    type: types.MACHINES.DELETE,
	    id: id
	  };
	};
	
	var moveMachine = exports.moveMachine = function moveMachine(id, x, y) {
	  return {
	    type: types.MACHINES.MOVE,
	    id: id,
	    x: x,
	    y: y
	  };
	};
	
	var selectMachine = exports.selectMachine = function selectMachine(id) {
	  return {
	    type: types.MACHINES.SELECT,
	    id: id
	  };
	};
	
	var clear = exports.clear = function clear() {
	  return function (dispatch, getState) {
	    return getState().get('game').get('machinesInScene').forEach(function (id) {
	      return dispatch(deleteMachine(id));
	    });
	  };
	};
	
	var restore = exports.restore = function restore(machines) {
	  return function (dispatch) {
	    dispatch(clear());
	
	    machines.forEach(function (_ref) {
	      var type = _ref.type;
	      var x = _ref.x;
	      var y = _ref.y;
	
	      var props = _objectWithoutProperties(_ref, ['type', 'x', 'y']);
	
	      return dispatch(addMachine(type, x, y, props, false));
	    });
	  };
	};

/***/ },
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(658),
	    listCacheDelete = __webpack_require__(659),
	    listCacheGet = __webpack_require__(660),
	    listCacheHas = __webpack_require__(661),
	    listCacheSet = __webpack_require__(662);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(182);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(655);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(51),
	    isSymbol = __webpack_require__(129);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(129);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Button;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(150);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Button(_ref) {
	  var className = _ref.className;
	  var block = _ref.block;
	  var danger = _ref.danger;
	
	  var props = _objectWithoutProperties(_ref, ['className', 'block', 'danger']);
	
	  return _react2.default.createElement('button', _extends({
	    className: (0, _classnames2.default)('Button', className, {
	      Button_block: block,
	      Button_danger: danger
	    })
	  }, props));
	}
	
	Button.propTypes = {
	  className: _react2.default.PropTypes.string,
	  block: _react2.default.PropTypes.bool,
	  danger: _react2.default.PropTypes.bool
	};

/***/ },
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(663),
	    mapCacheDelete = __webpack_require__(664),
	    mapCacheGet = __webpack_require__(665),
	    mapCacheHas = __webpack_require__(666),
	    mapCacheSet = __webpack_require__(667);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(62);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 181 */,
/* 182 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable import/prefer-default-export */
	var MACHINES = exports.MACHINES = {
	  ADD: 'MACHINES:ADD',
	  DELETE: 'MACHINES:DELETE',
	  MOVE: 'MACHINES:MOVE',
	  SELECT: 'MACHINES:SELECT'
	};

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var add = exports.add = function add(a, b) {
	  return a + b;
	};
	var subtract = exports.subtract = function subtract(a, b) {
	  return a - b;
	};
	var multiply = exports.multiply = function multiply(a, b) {
	  return a * b;
	};
	var divide = exports.divide = function divide(a, b) {
	  return a / b;
	};

/***/ },
/* 228 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEven = exports.isEven = function isEven(n) {
	  return n % 2 === 0;
	};
	var isOdd = exports.isOdd = function isOdd(n) {
	  return n % 2 === 1;
	};

/***/ },
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ function(module, exports) {

	module.exports = [
		{
			"type": "Source",
			"id": "Source1",
			"x": 100,
			"y": 100
		},
		{
			"type": "Separator",
			"id": "Separator2",
			"x": 100,
			"y": 200,
			"condition": "isEven"
		},
		{
			"type": "Destination",
			"id": "Destination3",
			"x": 65,
			"y": 320
		},
		{
			"type": "Cloner",
			"id": "Cloner4",
			"x": 135,
			"y": 340
		},
		{
			"type": "Combiner",
			"id": "Combiner5",
			"x": 135,
			"y": 470,
			"operation": "multiply"
		}
	];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(123),
	    stackClear = __webpack_require__(679),
	    stackDelete = __webpack_require__(680),
	    stackGet = __webpack_require__(681),
	    stackHas = __webpack_require__(682),
	    stackSet = __webpack_require__(683);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(612),
	    isFlattenable = __webpack_require__(653);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(267),
	    isKey = __webpack_require__(126),
	    toKey = __webpack_require__(128);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(620),
	    isObject = __webpack_require__(90),
	    isObjectLike = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 266 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(51),
	    stringToPath = __webpack_require__(684);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(606),
	    arraySome = __webpack_require__(614),
	    cacheHas = __webpack_require__(637);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 269 */,
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(90);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 271 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(634);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Controls = __webpack_require__(366);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Renderer = __webpack_require__(385);
	
	var _Renderer2 = _interopRequireDefault(_Renderer);
	
	var _MatterDebug = __webpack_require__(384);
	
	var _MatterDebug2 = _interopRequireDefault(_MatterDebug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.updateSize = function () {
	      var width = window.innerWidth;
	      var height = window.innerHeight;
	      var controlsWidth = Math.max(Math.round(width * 0.2), 300);
	      var gameWidth = width - controlsWidth;
	
	      _this.setState({ width: width, height: height, controlsWidth: controlsWidth, gameWidth: gameWidth });
	      _this.props.game.setSize(gameWidth, height);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { game: this.props.game };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateSize();
	      window.addEventListener('resize', this.updateSize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateSize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var game = _props.game;
	      var debug = _props.debug;
	      var _state = this.state;
	      var controlsWidth = _state.controlsWidth;
	      var gameWidth = _state.gameWidth;
	      var height = _state.height;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_Renderer2.default, { width: gameWidth, height: height }),
	        _react2.default.createElement(_Controls2.default, { width: controlsWidth }),
	        debug && _react2.default.createElement(_MatterDebug2.default, { engine: game.engine, width: gameWidth, height: height })
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	App.propTypes = {
	  game: _react2.default.PropTypes.object.isRequired,
	  debug: _react2.default.PropTypes.bool
	};
	App.childContextTypes = {
	  game: _react2.default.PropTypes.object.isRequired
	};
	exports.default = App;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _sample = __webpack_require__(696);
	
	var _sample2 = _interopRequireDefault(_sample);
	
	var _random = __webpack_require__(695);
	
	var _random2 = _interopRequireDefault(_random);
	
	var _game = __webpack_require__(93);
	
	var _Button = __webpack_require__(149);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _conditions = __webpack_require__(228);
	
	var conditions = _interopRequireWildcard(_conditions);
	
	var _binaryOps = __webpack_require__(227);
	
	var binaryOps = _interopRequireWildcard(_binaryOps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddButtons(_ref) {
	  var onBlockAdd = _ref.onBlockAdd;
	  var onClonerAdd = _ref.onClonerAdd;
	  var onCombinerAdd = _ref.onCombinerAdd;
	  var onDestinationAdd = _ref.onDestinationAdd;
	  var onSeparatorAdd = _ref.onSeparatorAdd;
	  var onSourceAdd = _ref.onSourceAdd;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AddButtons' },
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onBlockAdd },
	      'Add Block'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onClonerAdd },
	      'Add Cloner'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onCombinerAdd },
	      'Add Combiner'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onDestinationAdd },
	      'Add Destination'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onSeparatorAdd },
	      'Add Separator'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { block: true, onClick: onSourceAdd },
	      'Add Source'
	    )
	  );
	}
	
	AddButtons.propTypes = {
	  onBlockAdd: _react2.default.PropTypes.func.isRequired,
	  onClonerAdd: _react2.default.PropTypes.func.isRequired,
	  onCombinerAdd: _react2.default.PropTypes.func.isRequired,
	  onDestinationAdd: _react2.default.PropTypes.func.isRequired,
	  onSeparatorAdd: _react2.default.PropTypes.func.isRequired,
	  onSourceAdd: _react2.default.PropTypes.func.isRequired
	};
	
	var pos = function pos() {
	  return (0, _random2.default)(100, 600);
	};
	
	var mapDispatchToProps = {
	  onBlockAdd: function onBlockAdd() {
	    return (0, _game.addMachine)('Block', pos(), pos(), {
	      width: (0, _random2.default)(10, 100),
	      height: (0, _random2.default)(10, 100)
	    });
	  },
	  onClonerAdd: function onClonerAdd() {
	    return (0, _game.addMachine)('Cloner', pos(), pos());
	  },
	  onCombinerAdd: function onCombinerAdd() {
	    return (0, _game.addMachine)('Combiner', pos(), pos(), {
	      operation: (0, _sample2.default)(Object.keys(binaryOps))
	    });
	  },
	  onDestinationAdd: function onDestinationAdd() {
	    return (0, _game.addMachine)('Destination', pos(), pos());
	  },
	  onSeparatorAdd: function onSeparatorAdd() {
	    return (0, _game.addMachine)('Separator', pos(), pos(), {
	      condition: (0, _sample2.default)(Object.keys(conditions))
	    });
	  },
	  onSourceAdd: function onSourceAdd() {
	    return (0, _game.addMachine)('Source', pos(), pos());
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AddButtons);

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _classnames = __webpack_require__(150);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AddButtons = __webpack_require__(365);
	
	var _AddButtons2 = _interopRequireDefault(_AddButtons);
	
	var _MachineSettings = __webpack_require__(368);
	
	var _MachineSettings2 = _interopRequireDefault(_MachineSettings);
	
	var _Examples = __webpack_require__(367);
	
	var _Examples2 = _interopRequireDefault(_Examples);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Controls(_ref) {
	  var width = _ref.width;
	  var settingsActive = _ref.settingsActive;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('Controls', {
	        Controls_settingsActive: settingsActive
	      }),
	      style: { width: width + 'px' }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'Controls-main' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Programarble???'
	      ),
	      _react2.default.createElement(_AddButtons2.default, null),
	      _react2.default.createElement(_Examples2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Controls-settings' },
	      _react2.default.createElement(_MachineSettings2.default, null)
	    )
	  );
	}
	
	Controls.propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  settingsActive: _react2.default.PropTypes.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    settingsActive: state.get('game').get('selectionActive')
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Controls);

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _game = __webpack_require__(93);
	
	var _Button = __webpack_require__(149);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _examples = __webpack_require__(397);
	
	var examples = _interopRequireWildcard(_examples);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatName = function formatName(name) {
	  return name.replace(/([a-z])([A-Z])/g, function (_, a, b) {
	    return a + ' ' + b.toLowerCase();
	  });
	};
	
	function Examples(_ref) {
	  var onRestore = _ref.onRestore;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Examples' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Examples'
	    ),
	    Object.entries(examples).map(function (_ref2) {
	      var _ref3 = _slicedToArray(_ref2, 2);
	
	      var name = _ref3[0];
	      var example = _ref3[1];
	      return _react2.default.createElement(
	        _Button2.default,
	        { key: name, onClick: function onClick() {
	            return onRestore(example);
	          }, block: true },
	        formatName(name)
	      );
	    })
	  );
	}
	
	Examples.propTypes = {
	  onRestore: _react2.default.PropTypes.func.isRequired
	};
	
	var mapDispatchToProps = {
	  onRestore: _game.restore
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Examples);

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _reactImmutableProptypes = __webpack_require__(131);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _game = __webpack_require__(93);
	
	var _Button = __webpack_require__(149);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MachineSettings(_ref) {
	  var machine = _ref.machine;
	  var onDeselect = _ref.onDeselect;
	  var onDelete = _ref.onDelete;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'MachineSettings' },
	    _react2.default.createElement(
	      'div',
	      { className: 'MachineSettings-header' },
	      _react2.default.createElement(
	        _Button2.default,
	        { className: 'MachineSettings-header-back', onClick: onDeselect },
	        'Back'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        machine && machine.get('type')
	      )
	    ),
	    machine && _react2.default.createElement(
	      'div',
	      { className: 'MachineSettings-footer' },
	      _react2.default.createElement(
	        _Button2.default,
	        { danger: true, block: true, onClick: function onClick() {
	            return onDelete(machine.get('id'));
	          } },
	        'Delete'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'MachineSettings-debug' },
	        _react2.default.createElement(
	          'pre',
	          null,
	          JSON.stringify(machine, null, 2)
	        )
	      )
	    )
	  );
	}
	
	MachineSettings.propTypes = {
	  machine: _reactImmutableProptypes2.default.map,
	  onDeselect: _react2.default.PropTypes.func.isRequired,
	  onDelete: _react2.default.PropTypes.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var game = state.get('game');
	  var selectedMachine = game.get('selectedMachine');
	  return {
	    machine: game.get('machinesById').get(selectedMachine, null)
	  };
	};
	
	var mapDispatchToProps = {
	  onDeselect: function onDeselect() {
	    return (0, _game.selectMachine)(null);
	  },
	  onDelete: _game.deleteMachine
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MachineSettings);

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pixi = __webpack_require__(147);
	
	var _pixi2 = _interopRequireDefault(_pixi);
	
	var _reactPixi = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultRaw = true;
	
	var Graphics = function (_React$Component) {
	  _inherits(Graphics, _React$Component);
	
	  function Graphics() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Graphics);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Graphics.__proto__ || Object.getPrototypeOf(Graphics)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.mountGraphics = function (displayObject) {
	      if (displayObject) {
	        displayObject.addChild(_this.graphics);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Graphics, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.graphics = new _pixi2.default.Graphics();
	      this.draw(this.graphics);
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      this.graphics.clear();
	      _react2.default.Children.toArray(this.props.children).forEach(function (child) {
	        return child.type.draw(_this2.graphics, child.props);
	      });
	
	      if (!this.raw()) {
	        var bounds = this.graphics.getBounds();
	
	        this.setState({
	          texture: this.graphics.generateTexture(),
	          bounds: bounds
	        });
	      }
	    }
	  }, {
	    key: 'raw',
	    value: function raw() {
	      return this.props.raw != null ? this.props.raw : defaultRaw;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var texture = _state.texture;
	      var bounds = _state.bounds;
	
	      // eslint-disable-next-line no-unused-vars
	
	      var _props = this.props;
	      var _props$x = _props.x;
	      var x = _props$x === undefined ? 0 : _props$x;
	      var _props$y = _props.y;
	      var y = _props$y === undefined ? 0 : _props$y;
	      var children = _props.children;
	
	      var props = _objectWithoutProperties(_props, ['x', 'y', 'children']);
	
	      if (this.raw()) {
	        return _react2.default.createElement(_reactPixi.DisplayObjectContainer, _extends({
	          ref: this.mountGraphics,
	          x: x,
	          y: y
	        }, props));
	      }
	
	      return _react2.default.createElement(_reactPixi.Sprite, _extends({
	        texture: texture,
	        x: x + bounds.x,
	        y: y + bounds.y
	      }, props));
	    }
	  }]);
	
	  return Graphics;
	}(_react2.default.Component);
	
	Graphics.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  x: _react2.default.PropTypes.number,
	  y: _react2.default.PropTypes.number,
	  raw: _react2.default.PropTypes.bool
	};
	exports.default = Graphics;

/***/ },
/* 370 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var wrapDraw = function wrapDraw(draw) {
	  return function (graphics, props) {
	    graphics.lineWidth = props.lineWidth || 0;
	    graphics.lineColor = props.lineColor || 0;
	    graphics.lineAlpha = props.lineAlpha != null ? props.lineAlpha : 1;
	
	    var hasFill = props.fill != null;
	    if (hasFill) graphics.beginFill(props.fill, props.alpha);
	
	    draw(graphics, props);
	
	    if (hasFill) graphics.endFill();
	  };
	};
	
	exports.default = function (name, draw) {
	  var Component = function Component() {
	    throw new Error("Graphics." + draw + " can only be used as the direct child of <Graphics />");
	  };
	
	  Component.draw = wrapDraw(draw);
	  Component.displayName = name;
	
	  return Component;
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Block;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Block(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  return _react2.default.createElement(
	    g.Graphics,
	    { x: x, y: y },
	    _react2.default.createElement(g.Rectangle, {
	      fill: _constants.palette.black,
	      lineColor: _constants.palette.darkWhite,
	      lineWidth: 2,
	      x: -width / 2,
	      y: -height / 2,
	      width: width,
	      height: height
	    })
	  );
	}
	
	Block.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired,
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cloner;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matterJs = __webpack_require__(18);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var outputX = _Output2.default.width / 2;
	var outputY = _Output2.default.height / 2;
	var inputX = 0;
	
	var outputPos = { x: outputX, y: outputY };
	var onOutput = function onOutput(vec) {
	  return _matterJs.Vector.add(outputPos, _matterJs.Vector.rotate(vec, -(_constants.PORT_SEP / 2)));
	};
	
	var path = (0, _utils.toPath)((0, _utils.mirror)('y', [{ x: inputX, y: _constants.WALL_SIZE - _Input2.default.height }, { x: inputX + _Input2.default.width / 2, y: -_Input2.default.height }, { x: _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2, y: -_constants.MARBLE_RADIUS }, onOutput({ x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: -_constants.MARBLE_RADIUS }), onOutput({ x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: _constants.MARBLE_RADIUS - _constants.WALL_SIZE * 2 }), onOutput({ x: _constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE, y: _constants.MARBLE_RADIUS }), onOutput({ x: -(_constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE), y: _constants.MARBLE_RADIUS }), onOutput({ x: -(_constants.MARBLE_RADIUS + 2 * _constants.PAD), y: _constants.MARBLE_RADIUS - _constants.WALL_SIZE * 2 }), { x: 0.1, y: _constants.MARBLE_RADIUS }]));
	
	function Cloner(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	
	  return _react2.default.createElement(
	    g.Graphics,
	    { x: x, y: y },
	    _react2.default.createElement(g.Polygon, {
	      lineColor: _constants.palette.blue,
	      lineWidth: 2,
	      fill: _constants.palette.black,
	      path: path
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.blue,
	      y: -_constants.MARBLE_RADIUS - _constants.WALL_SIZE,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.blue,
	      x: outputX,
	      y: outputY,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS,
	      angle: -(_constants.PORT_SEP / 2)
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.blue,
	      x: -outputX,
	      y: outputY,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS,
	      angle: _constants.PORT_SEP / 2
	    })
	  );
	}
	
	Cloner.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cloner;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPixi = __webpack_require__(52);
	
	var _matterJs = __webpack_require__(18);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputX = (_Input2.default.width + _constants.WALL_SIZE + _constants.PAD) / 2;
	var inputY = -(_Input2.default.height / 2);
	
	var inputPos = { x: inputX, y: inputY };
	var onInput = function onInput(vec) {
	  return _matterJs.Vector.add(inputPos, _matterJs.Vector.rotate(vec, _constants.PORT_SEP / 2));
	};
	var inputTop = -(_constants.MARBLE_RADIUS + _constants.WALL_SIZE);
	var outputBottom = _Output2.default.height - _constants.WALL_SIZE / 2;
	
	var path = (0, _utils.toPath)((0, _utils.mirror)('y', [onInput({ x: -(_constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2), y: _constants.WALL_SIZE }), onInput({ x: -(_constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE), y: inputTop }), onInput({ x: 0, y: inputTop + _constants.WALL_SIZE }), onInput({ x: _constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE, y: inputTop }), onInput({ x: _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2, y: _constants.WALL_SIZE }), onInput({ x: _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2, y: _constants.MARBLE_RADIUS + _constants.WALL_SIZE }), { x: _constants.MARBLE_RADIUS + _constants.PAD, y: _constants.MARBLE_RADIUS }, { x: _constants.MARBLE_RADIUS + _constants.PAD, y: outputBottom - _constants.WALL_SIZE * 2 }, { x: _constants.MARBLE_RADIUS + _constants.WALL_SIZE + _constants.PAD, y: outputBottom }]));
	
	var operationToSymbol = {
	  add: '+',
	  subtract: '-',
	  multiply: '×',
	  divide: '÷'
	};
	
	var textStyle = {
	  font: '28px \'Source Code Pro\'',
	  fill: _constants.palette.str.yellow
	};
	
	var center = { x: 0.5, y: 0.5 };
	
	function Cloner(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	  var operation = _ref.operation;
	
	  return _react2.default.createElement(
	    _reactPixi.DisplayObjectContainer,
	    { x: x, y: y },
	    _react2.default.createElement(
	      g.Graphics,
	      null,
	      _react2.default.createElement(g.Polygon, {
	        lineColor: _constants.palette.yellow,
	        lineWidth: 2,
	        fill: _constants.palette.black,
	        path: path
	      }),
	      _react2.default.createElement(g.Arrow, {
	        fill: _constants.palette.yellow,
	        y: _Output2.default.height / 2,
	        width: _constants.WALL_SIZE * 2,
	        height: _constants.MARBLE_RADIUS
	      }),
	      _react2.default.createElement(g.Arrow, {
	        fill: _constants.palette.blue,
	        x: inputX,
	        y: inputY,
	        width: _constants.WALL_SIZE * 2,
	        height: _constants.MARBLE_RADIUS,
	        angle: _constants.PORT_SEP / 2
	      }),
	      _react2.default.createElement(g.Arrow, {
	        fill: _constants.palette.blue,
	        x: -inputX,
	        y: inputY,
	        width: _constants.WALL_SIZE * 2,
	        height: _constants.MARBLE_RADIUS,
	        angle: -(_constants.PORT_SEP / 2)
	      })
	    ),
	    _react2.default.createElement(_reactPixi.Text, { text: operationToSymbol[operation], style: textStyle, anchor: center, y: -_constants.WALL_SIZE })
	  );
	}
	
	Cloner.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired,
	  operation: _react2.default.PropTypes.oneOf(Object.keys(operationToSymbol)).isRequired
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Destination;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var top = -(_constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2);
	var path = (0, _utils.toPath)((0, _utils.mirror)('y', [{ x: _constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE, y: top }, { x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: top + _constants.WALL_SIZE * 2 }, { x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: -top }]));
	
	function Destination(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	
	  return _react2.default.createElement(
	    g.Graphics,
	    { x: x, y: y },
	    _react2.default.createElement(g.Polygon, {
	      fill: _constants.palette.black,
	      lineColor: _constants.palette.blue,
	      lineWidth: 2,
	      path: path
	    }),
	    _react2.default.createElement(g.Circle, { radius: 6, fill: _constants.palette.red })
	  );
	}
	
	Destination.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Separator;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matterJs = __webpack_require__(18);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var outputX = _Output2.default.width / 2;
	var outputY = _Output2.default.height / 2;
	var inputX = 0;
	
	var outputPos = { x: outputX, y: outputY };
	var onOutput = function onOutput(vec) {
	  return _matterJs.Vector.add(outputPos, _matterJs.Vector.rotate(vec, -(_constants.PORT_SEP / 2)));
	};
	
	var path = (0, _utils.toPath)((0, _utils.mirror)('y', [{ x: inputX, y: _constants.WALL_SIZE - _Input2.default.height }, { x: inputX + _Input2.default.width / 2, y: -_Input2.default.height }, { x: _constants.MARBLE_RADIUS + _constants.WALL_SIZE / 2, y: -_constants.MARBLE_RADIUS }, onOutput({ x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: -_constants.MARBLE_RADIUS }), onOutput({ x: _constants.MARBLE_RADIUS + 2 * _constants.PAD, y: _constants.MARBLE_RADIUS - _constants.WALL_SIZE * 2 }), onOutput({ x: _constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE, y: _constants.MARBLE_RADIUS }), onOutput({ x: -(_constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE), y: _constants.MARBLE_RADIUS }), onOutput({ x: -(_constants.MARBLE_RADIUS + 2 * _constants.PAD), y: _constants.MARBLE_RADIUS - _constants.WALL_SIZE * 2 }), { x: 0.1, y: _constants.MARBLE_RADIUS }]));
	
	function Separator(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	
	  return _react2.default.createElement(
	    g.Graphics,
	    { x: x, y: y },
	    _react2.default.createElement(g.Polygon, {
	      lineColor: _constants.palette.purple,
	      lineWidth: 2,
	      fill: _constants.palette.black,
	      path: path
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.purple,
	      y: -_constants.MARBLE_RADIUS - _constants.WALL_SIZE,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.green,
	      x: outputX,
	      y: outputY,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS,
	      angle: -(_constants.PORT_SEP / 2)
	    }),
	    _react2.default.createElement(g.Arrow, {
	      fill: _constants.palette.red,
	      x: -outputX,
	      y: outputY,
	      width: _constants.WALL_SIZE * 2,
	      height: _constants.MARBLE_RADIUS,
	      angle: _constants.PORT_SEP / 2
	    })
	  );
	}
	
	Separator.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Source;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _constants = __webpack_require__(23);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bottom = _constants.MARBLE_RADIUS;
	var top = -(_constants.MARBLE_RADIUS + _constants.WALL_SIZE);
	var flareRadius = _constants.MARBLE_RADIUS + _constants.PAD + _constants.WALL_SIZE;
	var flareTopRadius = _constants.MARBLE_RADIUS + _constants.PAD;
	var flareTop = _constants.MARBLE_RADIUS - _constants.WALL_SIZE * 2;
	
	var box = (0, _utils.toPath)((0, _utils.mirror)('y', [{ x: 0, y: top }, { x: flareTopRadius, y: top + _constants.WALL_SIZE }, { x: flareTopRadius, y: flareTop }, { x: flareRadius, y: bottom }]));
	
	function Source(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	
	  return _react2.default.createElement(
	    g.Graphics,
	    { x: x, y: y },
	    _react2.default.createElement(g.Polygon, { path: box, fill: _constants.palette.black, lineColor: _constants.palette.blue, lineWidth: 2 }),
	    _react2.default.createElement(g.Arrow, { fill: _constants.palette.green, height: _constants.MARBLE_RADIUS, width: 2 * _constants.WALL_SIZE })
	  );
	}
	
	Source.propTypes = {
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Block = __webpack_require__(371);
	
	Object.defineProperty(exports, 'Block', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Cloner = __webpack_require__(372);
	
	Object.defineProperty(exports, 'Cloner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cloner).default;
	  }
	});
	
	var _Combiner = __webpack_require__(373);
	
	Object.defineProperty(exports, 'Combiner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Combiner).default;
	  }
	});
	
	var _Destination = __webpack_require__(374);
	
	Object.defineProperty(exports, 'Destination', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Destination).default;
	  }
	});
	
	var _Source = __webpack_require__(376);
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Source).default;
	  }
	});
	
	var _Separator = __webpack_require__(375);
	
	Object.defineProperty(exports, 'Separator', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Separator).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPixi = __webpack_require__(52);
	
	var _matterJs = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dragThreshold = 5;
	var noop = function noop() {};
	
	var Interactive = function (_React$Component) {
	  _inherits(Interactive, _React$Component);
	
	  function Interactive() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Interactive);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Interactive.__proto__ || Object.getPrototypeOf(Interactive)).call.apply(_ref, [this].concat(args))), _this), _this.state = { dragging: false }, _this.handlePointerDown = function (e) {
	      if (_this.interaction) return;
	
	      _this.interaction = e.data;
	      _this.startPosition = e.data.global.clone();
	      _this.dragging = false;
	    }, _this.handlePointerMove = function (e) {
	      if (e.data !== _this.interaction) return;
	
	      if (!_this.dragging && _matterJs.Vector.magnitudeSquared(_matterJs.Vector.sub(_this.startPosition, e.data.global)) > dragThreshold) {
	        _this.dragging = true;
	        _this.props.onDragStart(_this.startPosition);
	      }
	
	      if (_this.dragging) _this.props.onDrag(e.data.global);
	    }, _this.handlePointerUp = function (e) {
	      if (e.data !== _this.interaction) return;
	
	      _this.interaction = null;
	
	      if (_this.dragging) {
	        _this.props.onDrag(e.data.global);
	        _this.props.onDragStop(e.data.global);
	      } else {
	        _this.props.onClick(e.data.global);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Interactive, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        _reactPixi.DisplayObjectContainer,
	        {
	          interactive: true,
	          mousedown: this.handlePointerDown,
	          touchstart: this.handlePointerDown,
	          mouseup: this.handlePointerUp,
	          mouseupoutside: this.handlePointerUp,
	          touchend: this.handlePointerUp,
	          touchendoutside: this.handlePointerUp,
	          mousemove: this.handlePointerMove,
	          touchmove: this.handlePointerMove
	        },
	        children
	      );
	    }
	  }]);
	
	  return Interactive;
	}(_react2.default.Component);
	
	Interactive.propTypes = {
	  onDragStart: _react2.default.PropTypes.func,
	  onDrag: _react2.default.PropTypes.func,
	  onDragStop: _react2.default.PropTypes.func,
	  onClick: _react2.default.PropTypes.func,
	  children: _react2.default.PropTypes.node.isRequired
	};
	Interactive.defaultProps = {
	  onDragStart: noop,
	  onDrag: noop,
	  onDragStop: noop,
	  onClick: noop
	};
	exports.default = Interactive;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _reactPixi = __webpack_require__(52);
	
	var _reactImmutableProptypes = __webpack_require__(131);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _machines = __webpack_require__(377);
	
	var machines = _interopRequireWildcard(_machines);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Machine(_ref) {
	  var machine = _ref.machine;
	
	  var type = machine.get('type');
	  var component = machines[type];
	  if (!component) return _react2.default.createElement(_reactPixi.Text, { text: 'Machine ' + type + ' not found' });
	  return _react2.default.createElement(component, machine.toObject());
	}
	
	Machine.propTypes = {
	  machine: _reactImmutableProptypes2.default.map.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref2) {
	  var machineId = _ref2.machineId;
	  return {
	    machine: state.get('game').get('machinesById').get(machineId)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Machine);

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _game = __webpack_require__(93);
	
	var _graphics = __webpack_require__(56);
	
	var g = _interopRequireWildcard(_graphics);
	
	var _Interactive = __webpack_require__(378);
	
	var _Interactive2 = _interopRequireDefault(_Interactive);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MachineInteraction = function (_React$Component) {
	  _inherits(MachineInteraction, _React$Component);
	
	  function MachineInteraction() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MachineInteraction);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MachineInteraction.__proto__ || Object.getPrototypeOf(MachineInteraction)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      _this.props.onSelectMachine(_this.props.selected ? null : _this.props.machineId);
	    }, _this.handleDragStart = function (_ref2) {
	      var x = _ref2.x;
	      var y = _ref2.y;
	
	      _this.startX = x;
	      _this.startY = y;
	      _this.startMachineX = _this.props.x;
	      _this.startMachineY = _this.props.y;
	
	      if (_this.props.selectionActive && !_this.props.selected) {
	        _this.props.onSelectMachine(_this.props.machineId);
	      }
	    }, _this.handleDrag = function (_ref3) {
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      var newMachineX = _this.startMachineX + (x - _this.startX);
	      var newMachineY = _this.startMachineY + (y - _this.startY);
	
	      _this.props.onMoveMachine(_this.props.machineId, newMachineX, newMachineY);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MachineInteraction, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var selected = _props.selected;
	      var x = _props.x;
	      var y = _props.y;
	
	      return _react2.default.createElement(
	        _Interactive2.default,
	        {
	          onClick: this.handleClick,
	          onDragStart: this.handleDragStart,
	          onDrag: this.handleDrag
	        },
	        children,
	        selected && _react2.default.createElement(
	          g.Graphics,
	          { x: x, y: y },
	          _react2.default.createElement(g.Circle, { lineColor: 0xffffff, lineAlpha: 0.2, lineWidth: 15, radius: 50 })
	        )
	      );
	    }
	  }]);
	
	  return MachineInteraction;
	}(_react2.default.Component);
	
	MachineInteraction.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  machineId: _react2.default.PropTypes.string.isRequired,
	  onMoveMachine: _react2.default.PropTypes.func.isRequired,
	  onSelectMachine: _react2.default.PropTypes.func.isRequired,
	  selected: _react2.default.PropTypes.bool.isRequired,
	  selectionActive: _react2.default.PropTypes.bool.isRequired,
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired
	};
	
	
	var mapStateToProps = function mapStateToProps(state, _ref4) {
	  var machineId = _ref4.machineId;
	
	  var game = state.get('game');
	  var machine = game.get('machinesById').get(machineId);
	  return {
	    x: machine.get('x'),
	    y: machine.get('y'),
	    selected: machineId === game.get('selectedMachine') && game.get('selectionActive'),
	    selectionActive: game.get('selectionActive')
	  };
	};
	
	var mapDispatchToProps = {
	  onMoveMachine: _game.moveMachine,
	  onSelectMachine: _game.selectMachine
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MachineInteraction);

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(53);
	
	var _reactPixi = __webpack_require__(52);
	
	var _reactImmutableProptypes = __webpack_require__(131);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _Machine = __webpack_require__(379);
	
	var _Machine2 = _interopRequireDefault(_Machine);
	
	var _MachineInteraction = __webpack_require__(380);
	
	var _MachineInteraction2 = _interopRequireDefault(_MachineInteraction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Machines(_ref) {
	  var machines = _ref.machines;
	
	  return _react2.default.createElement(
	    _reactPixi.DisplayObjectContainer,
	    null,
	    machines.map(function (machine) {
	      return _react2.default.createElement(
	        _MachineInteraction2.default,
	        { key: machine, machineId: machine },
	        _react2.default.createElement(_Machine2.default, { machineId: machine })
	      );
	    })
	  );
	}
	
	Machines.propTypes = {
	  machines: _reactImmutableProptypes2.default.set.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    machines: state.get('game').get('machinesInScene')
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Machines);

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Marble;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPixi = __webpack_require__(52);
	
	var _pixi = __webpack_require__(147);
	
	var _graphics = __webpack_require__(56);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textStyle = {
	  fill: _constants.palette.str.darkWhite,
	  fontFamily: '\'Source Sans Pro\'',
	  fontSize: '14px',
	  fontWeight: '200',
	  font: '14px \'Source Sans Pro\''
	};
	
	var center = new _pixi.Point(0.5, 0.5);
	
	function Marble(_ref) {
	  var x = _ref.x;
	  var y = _ref.y;
	  var angle = _ref.angle;
	  var value = _ref.value;
	
	  return _react2.default.createElement(
	    _reactPixi.DisplayObjectContainer,
	    { rotation: angle, x: x, y: y },
	    _react2.default.createElement(
	      _graphics.Graphics,
	      null,
	      _react2.default.createElement(_graphics.Circle, { x: 0, y: 0, radius: _constants.MARBLE_RADIUS, lineColor: _constants.palette.darkWhite, lineWidth: 2 })
	    ),
	    _react2.default.createElement(_reactPixi.Text, { text: value, style: textStyle, anchor: center })
	  );
	}
	
	Marble.propTypes = {
	  angle: _react2.default.PropTypes.number.isRequired,
	  x: _react2.default.PropTypes.number.isRequired,
	  y: _react2.default.PropTypes.number.isRequired,
	  value: _react2.default.PropTypes.any.isRequired
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPixi = __webpack_require__(52);
	
	var _Marble = __webpack_require__(382);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _Marble3 = __webpack_require__(84);
	
	var _Marble4 = _interopRequireDefault(_Marble3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Marbles = function (_React$Component) {
	  _inherits(Marbles, _React$Component);
	
	  function Marbles() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Marbles);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Marbles.__proto__ || Object.getPrototypeOf(Marbles)).call.apply(_ref, [this].concat(args))), _this), _this.loop = function () {
	      _this.frameRequestId = window.requestAnimationFrame(_this.loop);
	      _this.forceUpdate();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Marbles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loop();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.cancelAnimationFrame(this.frameRequestId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var marbles = this.context.game.marbles;
	
	
	      return _react2.default.createElement(
	        _reactPixi.DisplayObjectContainer,
	        null,
	        marbles.map(function (marble) {
	          var id = marble.id;
	          var angle = marble.angle;
	          var _marble$position = marble.position;
	          var x = _marble$position.x;
	          var y = _marble$position.y;
	
	          var value = _Marble4.default.getValue(marble);
	          return _react2.default.createElement(_Marble2.default, { key: id, x: x, y: y, angle: angle, value: value });
	        })
	      );
	    }
	  }]);
	
	  return Marbles;
	}(_react2.default.Component);
	
	Marbles.contextTypes = {
	  game: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Marbles;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matterJs = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MatterDebug = function (_React$Component) {
	  _inherits(MatterDebug, _React$Component);
	
	  function MatterDebug() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MatterDebug);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MatterDebug.__proto__ || Object.getPrototypeOf(MatterDebug)).call.apply(_ref, [this].concat(args))), _this), _this.attachRenderer = function (element) {
	      var _this$props = _this.props;
	      var width = _this$props.width;
	      var height = _this$props.height;
	      var engine = _this$props.engine;
	
	      _this.renderer = _matterJs.Render.create({
	        engine: engine,
	        element: element,
	        options: {
	          width: width,
	          height: height,
	          wireframeBackground: 'transparent'
	        }
	      });
	
	      _matterJs.Render.run(_this.renderer);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MatterDebug, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.renderer) _matterJs.Render.stop(this.renderer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'MatterDebug', ref: this.attachRenderer });
	    }
	  }]);
	
	  return MatterDebug;
	}(_react2.default.Component);
	
	MatterDebug.propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  engine: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MatterDebug;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Renderer;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPixi = __webpack_require__(52);
	
	var _Machines = __webpack_require__(381);
	
	var _Machines2 = _interopRequireDefault(_Machines);
	
	var _Marbles = __webpack_require__(383);
	
	var _Marbles2 = _interopRequireDefault(_Marbles);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Renderer(_ref) {
	  var width = _ref.width;
	  var height = _ref.height;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Renderer' },
	    _react2.default.createElement(
	      _reactPixi.Stage,
	      { backgroundcolor: _constants.palette.black, width: width, height: height, antialias: true },
	      _react2.default.createElement(_Marbles2.default, null),
	      _react2.default.createElement(_Machines2.default, null)
	    )
	  );
	}
	
	Renderer.propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = _Component2.default.create('Block', {
	  create: function create(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var width = _ref.width;
	    var height = _ref.height;
	
	    return _matterJs.Bodies.rectangle(x, y, width, height, {
	      isStatic: true
	    });
	  }
	});
	
	exports.default = Block;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Marble = __webpack_require__(84);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cloner = _Component2.default.create('Cloner', {
	  initialState: function initialState(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var rate = _ref.rate;
	
	    return {
	      input: _Input2.default.create({
	        x: x,
	        y: y - _Input2.default.height / 2,
	        isStatic: true,
	        rate: rate
	      }),
	      rightOutput: _Output2.default.create({
	        x: x + _Output2.default.width / 2,
	        y: y + _Output2.default.height / 2,
	        angle: -(_constants.PORT_SEP / 2),
	        isStatic: true,
	        rate: rate
	      }),
	      leftOutput: _Output2.default.create({
	        x: x - _Output2.default.width / 2,
	        y: y + _Output2.default.height / 2,
	        angle: _constants.PORT_SEP / 2,
	        isStatic: true,
	        rate: rate
	      })
	    };
	  },
	  create: function create(_ref2, _ref3) {
	    var x = _ref2.x;
	    var y = _ref2.y;
	    var input = _ref3.input;
	    var rightOutput = _ref3.rightOutput;
	    var leftOutput = _ref3.leftOutput;
	
	    return _matterJs.Composite.create({
	      bodies: [input, rightOutput, leftOutput]
	    });
	  },
	  beforeUpdate: function beforeUpdate(body, state) {
	    var input = state.input;
	    var leftOutput = state.leftOutput;
	    var rightOutput = state.rightOutput;
	
	    if (_Input2.default.canConsume(input) && _Output2.default.canProduce(leftOutput) && _Output2.default.canProduce(rightOutput)) {
	      var value = _Marble2.default.getValue(_Input2.default.consume(input));
	      _Output2.default.produce(leftOutput, value);
	      _Output2.default.produce(rightOutput, value);
	    }
	  }
	});
	
	exports.default = Cloner;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Marble = __webpack_require__(84);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _binaryOps = __webpack_require__(227);
	
	var binaryOps = _interopRequireWildcard(_binaryOps);
	
	var _constants = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Combiner = _Component2.default.create('Combiner', {
	  initialState: function initialState(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var rate = _ref.rate;
	    var operation = _ref.operation;
	
	    return {
	      operation: operation,
	      rightInput: _Input2.default.create({
	        x: x + _Input2.default.width / 2,
	        y: y - _Input2.default.height / 2,
	        angle: _constants.PORT_SEP / 2,
	        isStatic: true,
	        rate: rate
	      }),
	      leftInput: _Input2.default.create({
	        x: x - _Input2.default.width / 2,
	        y: y - _Input2.default.height / 2,
	        angle: -(_constants.PORT_SEP / 2),
	        isStatic: true,
	        rate: rate
	      }),
	      output: _Output2.default.create({
	        x: x,
	        y: y + _Output2.default.height / 2,
	        isStatic: true,
	        rate: rate
	      })
	    };
	  },
	  create: function create(_ref2, _ref3) {
	    var x = _ref2.x;
	    var y = _ref2.y;
	    var leftInput = _ref3.leftInput;
	    var rightInput = _ref3.rightInput;
	    var output = _ref3.output;
	
	    return _matterJs.Composite.create({
	      bodies: [rightInput, leftInput, output]
	    });
	  },
	  beforeUpdate: function beforeUpdate(body, state) {
	    var rightInput = state.rightInput;
	    var leftInput = state.leftInput;
	    var output = state.output;
	    var operation = state.operation;
	
	    if (_Input2.default.canConsume(leftInput) && _Input2.default.canConsume(rightInput) && _Output2.default.canProduce(output)) {
	      var left = _Marble2.default.getValue(_Input2.default.consume(leftInput));
	      var right = _Marble2.default.getValue(_Input2.default.consume(rightInput));
	      var op = binaryOps[operation];
	      _Output2.default.produce(output, op(left, right));
	    }
	  }
	});
	
	exports.default = Combiner;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Destination = _Component2.default.create('Destination', {
	  initialState: function initialState(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var rate = _ref.rate;
	
	    return {
	      input: _Input2.default.create({ x: x, y: y, rate: rate, isStatic: true })
	    };
	  },
	  create: function create(_, _ref2) {
	    var input = _ref2.input;
	
	    return input;
	  },
	  beforeUpdate: function beforeUpdate(body) {
	    if (_Input2.default.canConsume(body)) _Input2.default.consume(body);
	  }
	});
	
	exports.default = Destination;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Input = __webpack_require__(68);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Marble = __webpack_require__(84);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _constants = __webpack_require__(23);
	
	var _conditions = __webpack_require__(228);
	
	var conditions = _interopRequireWildcard(_conditions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Separator = _Component2.default.create('Separator', {
	  initialState: function initialState(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var condition = _ref.condition;
	    var rate = _ref.rate;
	
	    return {
	      condition: condition,
	      input: _Input2.default.create({
	        x: x,
	        y: y - _Input2.default.height / 2,
	        isStatic: true,
	        rate: rate
	      }),
	      rightOutput: _Output2.default.create({
	        x: x + _Output2.default.width / 2,
	        y: y + _Output2.default.height / 2,
	        angle: -(_constants.PORT_SEP / 2),
	        isStatic: true,
	        rate: rate
	      }),
	      leftOutput: _Output2.default.create({
	        x: x - _Output2.default.width / 2,
	        y: y + _Output2.default.height / 2,
	        angle: _constants.PORT_SEP / 2,
	        isStatic: true,
	        rate: rate
	      })
	    };
	  },
	  create: function create(_ref2, _ref3) {
	    var x = _ref2.x;
	    var y = _ref2.y;
	    var input = _ref3.input;
	    var rightOutput = _ref3.rightOutput;
	    var leftOutput = _ref3.leftOutput;
	
	    return _matterJs.Composite.create({
	      bodies: [input, rightOutput, leftOutput]
	    });
	  },
	  beforeUpdate: function beforeUpdate(body, state) {
	    var input = state.input;
	    var leftOutput = state.leftOutput;
	    var rightOutput = state.rightOutput;
	    var condition = state.condition;
	
	    if (_Input2.default.canConsume(input) && _Output2.default.canProduce(leftOutput) && _Output2.default.canProduce(rightOutput)) {
	      var value = _Marble2.default.getValue(_Input2.default.consume(input));
	      var fn = conditions[condition];
	      _Output2.default.produce(fn(value) ? rightOutput : leftOutput, value);
	    }
	  }
	});
	
	exports.default = Separator;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Output = __webpack_require__(69);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _Count = __webpack_require__(393);
	
	var _Count2 = _interopRequireDefault(_Count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Source = _Component2.default.create('Source', {
	  initialState: function initialState(_ref) {
	    var x = _ref.x;
	    var y = _ref.y;
	    var _ref$sequence = _ref.sequence;
	    var sequence = _ref$sequence === undefined ? new _Count2.default() : _ref$sequence;
	    var rate = _ref.rate;
	
	    return {
	      output: _Output2.default.create({ x: x, y: y, rate: rate, isStatic: true }),
	      sequence: sequence
	    };
	  },
	  create: function create(_, _ref2) {
	    var output = _ref2.output;
	
	    return output;
	  },
	  beforeUpdate: function beforeUpdate(body, _ref3) {
	    var sequence = _ref3.sequence;
	
	    if (_Output2.default.canProduce(body)) _Output2.default.produce(body, sequence.next());
	  }
	});
	
	exports.default = Source;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Block = __webpack_require__(386);
	
	Object.defineProperty(exports, 'Block', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Cloner = __webpack_require__(387);
	
	Object.defineProperty(exports, 'Cloner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cloner).default;
	  }
	});
	
	var _Combiner = __webpack_require__(388);
	
	Object.defineProperty(exports, 'Combiner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Combiner).default;
	  }
	});
	
	var _Destination = __webpack_require__(389);
	
	Object.defineProperty(exports, 'Destination', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Destination).default;
	  }
	});
	
	var _Separator = __webpack_require__(390);
	
	Object.defineProperty(exports, 'Separator', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Separator).default;
	  }
	});
	
	var _Source = __webpack_require__(391);
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Source).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 393 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Count = function () {
	  function Count() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref$min = _ref.min;
	    var min = _ref$min === undefined ? 0 : _ref$min;
	    var _ref$max = _ref.max;
	    var max = _ref$max === undefined ? Infinity : _ref$max;
	    var _ref$step = _ref.step;
	    var step = _ref$step === undefined ? 1 : _ref$step;
	
	    _classCallCheck(this, Count);
	
	    this.nextValue = min;
	    this.max = max;
	    this.step = step;
	  }
	
	  _createClass(Count, [{
	    key: "next",
	    value: function next() {
	      var value = this.nextValue;
	      this.nextValue += this.step;
	      return value;
	    }
	  }]);
	
	  return Count;
	}();
	
	exports.default = Count;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _matterJs = __webpack_require__(18);
	
	var _flatten = __webpack_require__(687);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasProp = function hasProp(key, type) {
	  return function (obj) {
	    return _typeof(obj[key]) === type;
	  };
	}; // eslint-disable-line valid-typeof
	
	/* eslint-disable no-console */
	var logEventSetup = function logEventSetup(event, components) {
	  console.group('Setup events: ' + event);
	  if (components.length === 0) console.log('none');
	  components.forEach(function (component) {
	    return Array.isArray(component) ? console.log(component[0].toString(), '💥', component[1].toString()) : console.log(component.componentId.toString());
	  });
	  console.groupEnd();
	};
	/* eslint-enable no-console */
	
	var eventNames = { start: 'collisionStart', end: 'collisionEnd' };
	
	exports.default = function (state, registered) {
	  var components = Object.values(registered);
	
	  var setupWorldEvent = function setupWorldEvent(eventName) {
	    var relevantComponents = components.filter(hasProp(eventName, 'function'));
	
	    var fireForBody = function fireForBody(body) {
	      relevantComponents.forEach(function (component) {
	        return (0, _utils.hasOwnProperty)(body, component.componentId) && component[eventName](body, component.getState(body), state);
	      });
	
	      if (body.type === 'composite') {
	        _matterJs.Composite.allBodies(body).forEach(fireForBody);
	      }
	    };
	
	    logEventSetup(eventName, relevantComponents);
	    _matterJs.Events.on(state.world, eventName, function (event) {
	      return Array.isArray(event.object) ? event.object.forEach(fireForBody) : fireForBody(event.object);
	    });
	  };
	
	  var setupEngineEvent = function setupEngineEvent(eventName) {
	    var relevantComponents = components.filter(hasProp(eventName, 'function'));
	    logEventSetup(eventName, relevantComponents);
	    _matterJs.Events.on(state.engine, eventName, function () {
	      return relevantComponents.forEach(function (component) {
	        return component.instances.forEach(function (body) {
	          return component[eventName](body, component.getState(body), state);
	        });
	      });
	    });
	  };
	
	  var fireCollision = function fireCollision(phase, typeA, bodyA, typeB, bodyB) {
	    var componentA = _Component2.default.registered[typeA];
	    var componentB = _Component2.default.registered[typeB];
	    var componentState = componentA.getState(bodyA);
	
	    componentA.collisions[componentB.name][phase](bodyA, componentState, bodyB, state);
	  };
	
	  var setupCollisionEvents = function setupCollisionEvents(phase) {
	    var eventName = eventNames[phase];
	
	    var pairs = (0, _flatten2.default)(components.filter(hasProp('collisions', 'object')).map(function (component) {
	      return Object.keys(component.collisions).filter(function (key) {
	        return hasProp(phase, 'function')(component.collisions[key]);
	      }).map(function (key) {
	        return [component.componentId, _Component2.default.get(key).componentId];
	      });
	    }));
	
	    logEventSetup(eventName, pairs);
	
	    _matterJs.Events.on(state.engine, eventName, function (event) {
	      return event.pairs.forEach(function (pair) {
	        return pairs.forEach(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var typeA = _ref2[0];
	          var typeB = _ref2[1];
	
	          if ((0, _utils.hasOwnProperty)(pair.bodyA, typeA) && (0, _utils.hasOwnProperty)(pair.bodyB, typeB)) {
	            fireCollision(phase, typeA, pair.bodyA, typeB, pair.bodyB, pair);
	          } else if ((0, _utils.hasOwnProperty)(pair.bodyB, typeA) && (0, _utils.hasOwnProperty)(pair.bodyA, typeB)) {
	            fireCollision(phase, typeA, pair.bodyB, typeB, pair.bodyA, pair);
	          }
	        });
	      });
	    });
	  };
	
	  setupWorldEvent('beforeAdd');
	  setupWorldEvent('afterAdd');
	  setupWorldEvent('beforeRemove');
	  setupWorldEvent('afterRemove');
	  setupCollisionEvents('start');
	  setupCollisionEvents('end');
	  setupEngineEvent('beforeUpdate');
	  setupEngineEvent('afterUpdate');
	};

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _Component = __webpack_require__(33);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Marble = __webpack_require__(84);
	
	var _Marble2 = _interopRequireDefault(_Marble);
	
	var _setupEvents = __webpack_require__(394);
	
	var _setupEvents2 = _interopRequireDefault(_setupEvents);
	
	var _syncStore = __webpack_require__(396);
	
	var _syncStore2 = _interopRequireDefault(_syncStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (store) {
	  var engine = _matterJs.Engine.create();
	  var world = engine.world;
	
	  var game = {
	    engine: engine,
	    world: world,
	    marbles: _Marble2.default.instances,
	    bounds: {
	      min: { x: 0, y: 0 },
	      max: { x: Infinity, y: Infinity }
	    },
	
	    setSize: function setSize(width, height) {
	      game.bounds.max.x = width;
	      game.bounds.max.y = height;
	    }
	  };
	
	  (0, _setupEvents2.default)(game, _Component2.default.registered);
	  (0, _syncStore2.default)(game, store);
	  _matterJs.Engine.run(engine);
	
	  window.game = game;
	  return game;
	};

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matterJs = __webpack_require__(18);
	
	var _immutable = __webpack_require__(98);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _machines = __webpack_require__(392);
	
	var machines = _interopRequireWildcard(_machines);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref, store) {
	  var engine = _ref.engine;
	  var world = _ref.world;
	
	  var instancesById = {};
	
	  var lastMachinesInScene = _immutable2.default.Set();
	  var lastMachinesById = _immutable2.default.Map();
	
	  _matterJs.Events.on(engine, 'beforeUpdate', function () {
	    var state = store.getState().get('game');
	    var machinesById = state.get('machinesById');
	    var machinesInScene = state.get('machinesInScene');
	
	    if (!machinesInScene.equals(lastMachinesInScene)) {
	      var added = machinesInScene.subtract(lastMachinesInScene).map(function (machineId) {
	        var machine = machinesById.get(machineId).toObject();
	        var machineClass = machines[machine.type];
	        if (!machineClass) throw new Error('Unknown machine type ' + machine.type);
	
	        var instance = machineClass.create(machine);
	        instancesById[machineId] = instance;
	
	        return instance;
	      }).toArray();
	
	      if (added.length) _matterJs.World.add(world, added);
	
	      lastMachinesInScene.subtract(machinesInScene).forEach(function (machineId) {
	        console.log('REMOVE', machineId);
	        var instance = instancesById[machineId];
	        if (!instance) throw new Error('Unknown instance ' + machineId);
	        instancesById[machineId] = undefined;
	        _matterJs.World.remove(world, instance);
	      });
	    }
	
	    if (!machinesById.equals(lastMachinesById)) {
	      Object.keys(instancesById).forEach(function (id) {
	        var machine = machinesById.get(id);
	        if (!machine) return;
	        if (!machine.equals(lastMachinesById.get(id))) {
	          var machineObj = machine.toObject();
	          var machineClass = machines[machineObj.type];
	          if (!machineClass) throw new Error('Unknown machine type ' + machineObj.type);
	          machineClass.updateFromStore(instancesById[id], machineObj);
	        }
	      });
	    }
	
	    lastMachinesInScene = machinesInScene;
	    lastMachinesById = machinesById;
	  });
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blank = __webpack_require__(600);
	
	Object.defineProperty(exports, 'blank', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blank).default;
	  }
	});
	
	var _backPressure = __webpack_require__(599);
	
	Object.defineProperty(exports, 'backPressure', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_backPressure).default;
	  }
	});
	
	var _ones = __webpack_require__(601);
	
	Object.defineProperty(exports, 'ones', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ones).default;
	  }
	});
	
	var _squaresOfEvenNumbers = __webpack_require__(260);
	
	Object.defineProperty(exports, 'squaresOfEvenNumbers', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_squaresOfEvenNumbers).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(287);
	
	var _reactRedux = __webpack_require__(53);
	
	var _App = __webpack_require__(364);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(400);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _game = __webpack_require__(93);
	
	var _start = __webpack_require__(395);
	
	var _start2 = _interopRequireDefault(_start);
	
	var _squaresOfEvenNumbers = __webpack_require__(260);
	
	var _squaresOfEvenNumbers2 = _interopRequireDefault(_squaresOfEvenNumbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var game = (0, _start2.default)(_store2.default);
	var debug = false;
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: _store2.default },
	  _react2.default.createElement(_App2.default, { game: game, debug: debug })
	), document.getElementById('content'));
	
	_store2.default.dispatch((0, _game.restore)(_squaresOfEvenNumbers2.default));
	
	// debug / example saving biz:
	
	window.dumpState = function () {
	  var state = _store2.default.getState().get('game');
	  var machines = state.get('machinesById');
	
	  var dump = state.get('machinesInScene').map(function (id) {
	    return machines.get(id).delete('id');
	  });
	
	  return JSON.stringify(dump, null, 2);
	};
	
	window.restoreState = function (state) {
	  return _store2.default.dispatch((0, _game.restore)(state));
	};
	
	window.clean = function () {
	  return window.restoreState(JSON.parse(window.dumpState()));
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(98);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _types = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = _immutable2.default.Map({
	  machinesById: _immutable2.default.Map(),
	  machinesInScene: _immutable2.default.Set(),
	  selectionActive: false
	});
	
	var reducers = (_reducers = {}, _defineProperty(_reducers, _types.MACHINES.ADD, function (state, _ref) {
	  var machineType = _ref.machineType;
	  var id = _ref.id;
	  var x = _ref.x;
	  var y = _ref.y;
	  var props = _ref.props;
	  var select = _ref.select;
	  return state.setIn(['machinesById', id], _immutable2.default.Map(_extends({ type: machineType, id: id, x: x, y: y }, props))).update('machinesInScene', function (machinesInScene) {
	    return machinesInScene.add(id);
	  }).update('selectedMachine', function (selected) {
	    return select ? id : selected;
	  }).set('selectionActive', !!select);
	}), _defineProperty(_reducers, _types.MACHINES.DELETE, function (state, _ref2) {
	  var id = _ref2.id;
	  return state.deleteIn(['machinesById', id]).update('machinesInScene', function (machinesInScene) {
	    return machinesInScene.delete(id);
	  }).update('selectedMachine', function (selected) {
	    return state.get('selectedMachine') === id ? null : selected;
	  }).update('selectionActive', function (selected) {
	    return state.get('selectedMachine') === id ? false : selected;
	  });
	}), _defineProperty(_reducers, _types.MACHINES.MOVE, function (state, _ref3) {
	  var id = _ref3.id;
	  var x = _ref3.x;
	  var y = _ref3.y;
	  return state.updateIn(['machinesById', id], function (machine) {
	    return machine.set('x', x).set('y', y);
	  });
	}), _defineProperty(_reducers, _types.MACHINES.SELECT, function (state, _ref4) {
	  var id = _ref4.id;
	  return state.update('selectedMachine', function (selected) {
	    return id == null ? selected : id;
	  }).set('selectionActive', id != null);
	}), _reducers);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  if (!reducers[action.type]) return state;
	  return reducers[action.type](state, action);
	};

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(215);
	
	var _immutable = __webpack_require__(98);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxThunk = __webpack_require__(319);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _game = __webpack_require__(399);
	
	var _game2 = _interopRequireDefault(_game);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	var reducer = function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	  return state.update('game', function (gameState) {
	    return (0, _game2.default)(gameState, action);
	  });
	};
	
	var store = (0, _redux.createStore)(reducer, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	}));
	
	exports.default = store;

/***/ },
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "style.css";

/***/ },
/* 597 */,
/* 598 */,
/* 599 */
/***/ function(module, exports) {

	module.exports = [
		{
			"type": "Cloner",
			"y": 344,
			"x": 388,
			"rate": 0
		},
		{
			"type": "Combiner",
			"operation": "subtract",
			"x": 427,
			"y": 606
		},
		{
			"type": "Cloner",
			"y": 207,
			"x": 426,
			"rate": 0
		},
		{
			"type": "Combiner",
			"operation": "add",
			"x": 387,
			"y": 482,
			"rate": 300
		},
		{
			"type": "Source",
			"y": 87,
			"x": 428,
			"rate": 0
		},
		{
			"type": "Block",
			"height": 60,
			"x": 428,
			"y": 535,
			"width": 25
		},
		{
			"type": "Block",
			"height": 60,
			"x": 365,
			"y": 545,
			"width": 15
		},
		{
			"type": "Block",
			"height": 60,
			"x": 330,
			"y": 410,
			"width": 15
		},
		{
			"type": "Block",
			"height": 60,
			"x": 388,
			"y": 410,
			"width": 15
		},
		{
			"type": "Block",
			"height": 300,
			"x": 438,
			"y": 410,
			"width": 7
		},
		{
			"type": "Block",
			"height": 50,
			"x": 405,
			"y": 140,
			"width": 7
		},
		{
			"type": "Block",
			"height": 50,
			"x": 450,
			"y": 140,
			"width": 7
		},
		{
			"type": "Block",
			"height": 50,
			"x": 415,
			"y": 280,
			"width": 7
		},
		{
			"type": "Block",
			"height": 50,
			"x": 370,
			"y": 280,
			"width": 7
		},
		{
			"type": "Block",
			"height": 350,
			"x": 480,
			"y": 400,
			"width": 7
		}
	];

/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = [];

/***/ },
/* 601 */
/***/ function(module, exports) {

	module.exports = [
		{
			"type": "Separator",
			"condition": "isEven",
			"x": 439,
			"y": 194
		},
		{
			"type": "Combiner",
			"operation": "subtract",
			"x": 440,
			"y": 309
		},
		{
			"type": "Cloner",
			"y": 413,
			"x": 443
		},
		{
			"type": "Combiner",
			"operation": "multiply",
			"x": 446,
			"y": 524
		},
		{
			"type": "Source",
			"y": 99,
			"x": 439
		}
	];

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(648),
	    hashDelete = __webpack_require__(649),
	    hashGet = __webpack_require__(650),
	    hashHas = __webpack_require__(651),
	    hashSet = __webpack_require__(652);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(179),
	    setCacheAdd = __webpack_require__(674),
	    setCacheHas = __webpack_require__(675);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(62);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(79),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(266);
	
	/**
	 * A specialized version of `_.sample` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @returns {*} Returns the random element.
	 */
	function arraySample(array) {
	  var length = array.length;
	  return length ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = arraySample;


/***/ },
/* 614 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(617),
	    createBaseEach = __webpack_require__(639);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(640);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(616),
	    keys = __webpack_require__(100);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 618 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 619 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(261),
	    equalArrays = __webpack_require__(268),
	    equalByTag = __webpack_require__(641),
	    equalObjects = __webpack_require__(642),
	    getTag = __webpack_require__(645),
	    isArray = __webpack_require__(51),
	    isTypedArray = __webpack_require__(691);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(261),
	    baseIsEqual = __webpack_require__(265);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 622 */,
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(185),
	    isObjectLike = __webpack_require__(99);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(627),
	    baseMatchesProperty = __webpack_require__(628),
	    identity = __webpack_require__(183),
	    isArray = __webpack_require__(51),
	    property = __webpack_require__(694);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 625 */,
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(615),
	    isArrayLike = __webpack_require__(80);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(621),
	    getMatchData = __webpack_require__(643),
	    matchesStrictComparable = __webpack_require__(271);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(265),
	    get = __webpack_require__(688),
	    hasIn = __webpack_require__(689),
	    isKey = __webpack_require__(126),
	    isStrictComparable = __webpack_require__(270),
	    matchesStrictComparable = __webpack_require__(271),
	    toKey = __webpack_require__(128);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 629 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(264);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    isSymbol = __webpack_require__(129);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 635 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(262);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 637 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 638 */,
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(80);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 640 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    Uint8Array = __webpack_require__(607),
	    eq = __webpack_require__(182),
	    equalArrays = __webpack_require__(268),
	    mapToArray = __webpack_require__(668),
	    setToArray = __webpack_require__(676);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(100);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(270),
	    keys = __webpack_require__(100);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 644 */,
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(602),
	    Map = __webpack_require__(178),
	    Promise = __webpack_require__(604),
	    Set = __webpack_require__(605),
	    WeakMap = __webpack_require__(608),
	    baseGetTag = __webpack_require__(618),
	    toSource = __webpack_require__(273);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 646 */,
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(267),
	    isArguments = __webpack_require__(184),
	    isArray = __webpack_require__(51),
	    isIndex = __webpack_require__(181),
	    isKey = __webpack_require__(126),
	    isLength = __webpack_require__(185),
	    toKey = __webpack_require__(128);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(127);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 649 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(127);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(127);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(127);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(180),
	    isArguments = __webpack_require__(184),
	    isArray = __webpack_require__(51);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(182),
	    isArrayLike = __webpack_require__(80),
	    isIndex = __webpack_require__(181),
	    isObject = __webpack_require__(90);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 655 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 656 */,
/* 657 */,
/* 658 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(603),
	    ListCache = __webpack_require__(123),
	    Map = __webpack_require__(178);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(125);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(125);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(125);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(125);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 668 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(693);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 670 */,
/* 671 */,
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(269);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(351)(module)))

/***/ },
/* 673 */,
/* 674 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 675 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 677 */,
/* 678 */,
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(123);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 680 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 681 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 682 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(123),
	    Map = __webpack_require__(178),
	    MapCache = __webpack_require__(179);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(669),
	    toString = __webpack_require__(278);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 685 */,
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(263),
	    map = __webpack_require__(692);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(263);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(264);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(619),
	    hasPath = __webpack_require__(647);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 690 */,
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(623),
	    baseUnary = __webpack_require__(635),
	    nodeUtil = __webpack_require__(672);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(262),
	    baseIteratee = __webpack_require__(624),
	    baseMap = __webpack_require__(626),
	    isArray = __webpack_require__(51);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(179);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(629),
	    basePropertyDeep = __webpack_require__(630),
	    isKey = __webpack_require__(126),
	    toKey = __webpack_require__(128);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(266),
	    isIterateeCall = __webpack_require__(654),
	    toFinite = __webpack_require__(277);
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseFloat = parseFloat;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min,
	    nativeRandom = Math.random;
	
	/**
	 * Produces a random number between the inclusive `lower` and `upper` bounds.
	 * If only one argument is provided a number between `0` and the given number
	 * is returned. If `floating` is `true`, or either `lower` or `upper` are
	 * floats, a floating-point number is returned instead of an integer.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Number
	 * @param {number} [lower=0] The lower bound.
	 * @param {number} [upper=1] The upper bound.
	 * @param {boolean} [floating] Specify returning a floating-point number.
	 * @returns {number} Returns the random number.
	 * @example
	 *
	 * _.random(0, 5);
	 * // => an integer between 0 and 5
	 *
	 * _.random(5);
	 * // => also an integer between 0 and 5
	 *
	 * _.random(5, true);
	 * // => a floating-point number between 0 and 5
	 *
	 * _.random(1.2, 5.2);
	 * // => a floating-point number between 1.2 and 5.2
	 */
	function random(lower, upper, floating) {
	  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	    upper = floating = undefined;
	  }
	  if (floating === undefined) {
	    if (typeof upper == 'boolean') {
	      floating = upper;
	      upper = undefined;
	    }
	    else if (typeof lower == 'boolean') {
	      floating = lower;
	      lower = undefined;
	    }
	  }
	  if (lower === undefined && upper === undefined) {
	    lower = 0;
	    upper = 1;
	  }
	  else {
	    lower = toFinite(lower);
	    if (upper === undefined) {
	      upper = lower;
	      lower = 0;
	    } else {
	      upper = toFinite(upper);
	    }
	  }
	  if (lower > upper) {
	    var temp = lower;
	    lower = upper;
	    upper = temp;
	  }
	  if (floating || lower % 1 || upper % 1) {
	    var rand = nativeRandom();
	    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	  }
	  return baseRandom(lower, upper);
	}
	
	module.exports = random;


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(613),
	    isArrayLike = __webpack_require__(80),
	    values = __webpack_require__(700);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  return arraySample(isArrayLike(collection) ? collection : values(collection));
	}
	
	module.exports = sample;


/***/ },
/* 697 */,
/* 698 */,
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(278);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(636),
	    keys = __webpack_require__(100);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.js
 **/